import type React from 'react'
import styles from './RowChevron.module.css'

/**
 * The trailing "›" of a tappable row — Figma's own chevron, a text glyph
 * (`›`, semiboldPx16, text-secondary) on SD/TransferRow,
 * SD/StationDetailsLink and the line view's station rows. One component so
 * every row on the station and line surfaces shows the same mark.
 */
export function RowChevron(): React.ReactElement {
  return (
    <span className={styles.chevron} aria-hidden="true" data-testid="row-chevron">
      ›
    </span>
  )
}
